<template>
  <!-- <div class="none-data-container flex-center" :class="version == 'horiz'?'h-17':'h-19'"> -->
  <div class="none-data-container flex-center">
    <div class="none-wraper">
      <img v-if="tipVal == '暂无数据'" :src="require('../assets/images/no-dev-list.png')"/>
      <p class="font-18" v-else>{{tipVal}}</p>
    </div>
  </div>
</template>

<script>
export default { 
  props:{
    version:{
      type:String,
    },
    tips:{
      type:String,
      default:'暂无数据'
    }
  },
  data(){
    return{
      tipVal:this.tips
    } 
  },
  created(){
    this.initPage()
  },
  methods:{
    initPage(){
      let user = JSON.parse(localStorage.getItem('user'));
      if(user.defaultProjectSortId && user.defaultProjectSortId.length>0){
          let idArr = new Set(user.defaultProjectSortId[0].split(',')); 
          let milidArr;
          if(localStorage.getItem('projectSortIdList')){
            let milidArrId = localStorage.getItem('projectSortIdList'); 
            milidArr = new Set(milidArrId.split(','));
          }  
          this.militaryId =  Array.from(new Set([...idArr].filter(item => !milidArr.has(item))));  
          if(this.militaryId.length>0){
            this.tipVal = '暂无数据'
          }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.h-19{ 
    height: 19.3rem;  
}
.h-17{ 
    height: 15rem;  
}
.none-data-container{   
  width: 100%; 
  height: 100%;
  font-family: "Microsoft YaHei";
  .none-wraper{
    width: 9.375rem;  
    img{
      width: 9rem;
      height: 7rem; 
      margin: 0 auto;
    }
    p{
      text-align: center; 
      // margin-top: .625rem;
      color: #ccc;
      font-weight:bold; 
      font-family: Microsoft YaHei;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NoneData.vue